<section>
  <div
    class="mainGridRgt11"
    style="
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      color: white;
      border-bottom: 2px solid;
    "
  >
    <div class="asImgBoxTop pt-2">
      <div class="asImgBoxTopTxt">Kiln-Critical Parameters</div>
    </div>
    <div style="display: flex">
      <div class="mr-2 date-picker">
        <mat-form-field class="padding-test" appearance="outline">
          <mat-label style="color: white">Date</mat-label>
          <input
            style="color: white; font-size: 15px"
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="startdate"
            placeholder="Choose Start Date"
            [(ngModel)]="appliedDateFilters.start_date"
            [disabled]="false"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startdate"
          ></mat-datepicker-toggle>
          <mat-datepicker #startdate></mat-datepicker>
        </mat-form-field>
      </div>
      <button
        class="btn1"
        title="Select the date and click."
        style="
          font-size: 16px;
          width: 70px;
          cursor: pointer;
          background-color: #302c2c;
          outline: unset;
          /* margin-left: 4%; */
          /* padding-top: 2px; */
          border: 1px solid rgba(255, 255, 255, 0.38);
          height: 35px;
          border-radius: 0.9375em !important;
        "
        mat-raised-button
        color="primary"
        class="get-sm-btn"
        (click)="changeDate()"
      >
        Apply
      </button>
    </div>
    <!-- <div  style="display: flex;margin-left: 15px;margin-right: 2px; font-size: 20px; font-weight: 600;">Status:
          <span style="margin-left:6px;margin-right:6px;" [ngStyle]="{'color': coloval}" >  {{checkstatus}}</span>
        </div> -->
  </div>
  <div *ngIf="!isLoading" 
    style="
      font-size: 13px;
      flex-direction: column;
      display: flex;
      justify-content: space-evenly;
      height: 590px;
    "
  >
    <div style="display: flex; flex-direction: row; justify-content: flex-end">
      <p
        style="
          margin: 0px;
          margin-left: 10px;
          font-weight: 400;
          font-size: 20px;
          color: #fff;
        "
      >
        Alert Level:
      </p>
      &nbsp;&nbsp;
      <button
        style="
          height: 10px;
          width: 17px;
          left: 66px;
          top: 860px;
          margin-top: 11px;
          border-radius: 10px;
          border-width: 0px;
          /* background: #0eab73; */
        "
        [ngStyle]="{
          background: this.colorMix1 == 'G' ? '#39FF14' : '#0a3207'
        }"
      ></button
      >&nbsp;&nbsp;
      <button
        style="
          height: 10px;
          width: 17px;
          left: 66px;
          top: 860px;
          margin-top: 11px;
          border-radius: 10px;
          border-width: 0px;
          /* background: #e5b027; */
        "
        [ngStyle]="{
          background: this.colorMix1 == 'Y' ? '#e5b027' : '#332f00'
        }"
      ></button
      >&nbsp;&nbsp;
      <button
        style="
          height: 10px;
          width: 17px;
          left: 66px;
          top: 860px;
          margin-top: 11px;
          border-radius: 10px;
          border-width: 0px;
          /* background: #c7152a; */
        "
        [ngStyle]="{
          background: this.colorMix1 == 'R' ? '#c7152a' : '#300'
        }"
      ></button
      >&nbsp;&nbsp;
    </div>
    <div class="red1">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 1%;
        "
      >
        <p class="mainGridtitle1">Real Time Critical Parameters</p>
        <span style="color: #fff">
          <tr *ngFor="let vval of ActualForecastKilndata">
            <!-- <td>{{vval.obs_time | date:'dd/MM/yyyy, HH:mm:ss'}}                 
                      </td> -->
            <td>Time -&nbsp;{{ vval.obs_time | date : "HH:mm" }}</td>
          </tr>
        </span>
      </div>
      <div class="row" style="padding: 1%">
        <div class="col-md-6">
          <div
            class="red"
            style="
              border-radius: 6px;
              box-shadow: inset 7px 7px 14px black, inset -7px -7px 14px #5a5a5a;
            "  
          >   
           <label for="temp">Free Lime (%)</label>
          <span *ngIf="ActualForecastKilndata.length != 0">
         
            <div *ngFor="let vval of ActualForecastKilndata">
              <label class="per" *ngIf="vval.f_cao < 0">0.00</label>
              <label class="per" *ngIf="vval.f_cao >= 0">
                {{ vval.f_cao }}
              </label>
            </div>
          </span>
           
            <div *ngIf="ActualForecastKilndata.length == 0 || null">
              <label class="per">No data</label>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="red"
            style="
              border-radius: 6px;
              box-shadow: inset 7px 7px 14px black, inset -7px -7px 14px #5a5a5a;
            "
          >
            <label for="temp">Burning Zone Temp (°C)</label>
            <span  *ngIf="ActualForecastKilndata.length != 0" >
            <div  *ngFor="let vval of ActualForecastKilndata">
              <label class="per" *ngIf="vval.burning_zone_temp < 0">0.00</label>
              <label class="per" *ngIf="vval.burning_zone_temp >= 0">
                {{ vval.burning_zone_temp }}
              </label>
            </div>
          </span>
            <div *ngIf="ActualForecastKilndata.length == 0 || null">
              <label class="per">No data</label>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
              <div class="red" style="border-radius: 6px;
            box-shadow: inset 7px 7px 14px black,
                        inset -7px -7px 14px #5a5a5a;">
                <label for="temp">Kiln Feed (TPH)</label>
                <div *ngIf="Realtimedata.length !=0 ">
                  <label class="per" *ngIf="vval.kiln_feed < 0 ">0.00</label>
                  <label class="per" *ngIf="vval.kiln_feed >=  0 ">{{vval.kiln_feed}}</label>
                </div>
                <div *ngIf="Realtimedata.length ==0 || null "><label class="per">No data</label></div>
              </div>
            </div> -->
      </div>
      <div class="row" style="padding: 1%">
        <div class="col-md-6" >
          <div
            class="red"
            style="
              border-radius: 6px;
              box-shadow: inset 7px 7px 14px black, inset -7px -7px 14px #5a5a5a;
            "
          >
            <label for="temp"
              >Kiln Inlet O2 (%)
              <!-- (M<sup>3</sup>/Hr) -->
            </label>
            <span *ngIf="ActualForecastKilndata.length != 0">
            <div *ngFor="let vval of ActualForecastKilndata">
              <label class="per" *ngIf="vval.kiln_inlet_o2 < 0">0.00</label>
              <label class="per" *ngIf="vval.kiln_inlet_o2 >= 0">
                {{ vval.kiln_inlet_o2 }}
              </label>
            </div>
          </span>
            <div *ngIf="ActualForecastKilndata.length == 0 || null">
              <label class="per">No data</label>
            </div>
          </div>
        </div>

        <div class="col-md-6" >
          <div
            class="red"
            style="
              border-radius: 6px;
              box-shadow: inset 7px 7px 14px black, inset -7px -7px 14px #5a5a5a;
            "
          >
            <label for="temp">Kiln Inlet CO (%)</label>
            <span *ngIf="ActualForecastKilndata.length != 0">
            <div *ngFor="let vval of ActualForecastKilndata">
              <label class="per" *ngIf="vval.kiln_inlet_co < 0">0.00</label>
              <label class="per" *ngIf="vval.kiln_inlet_co >= 0">
                {{ vval.kiln_inlet_co }}
              </label>
            </div>
          </span>
            <div *ngIf="ActualForecastKilndata.length == 0 || null">
              <label class="per">No data</label>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
              <div class="red" style="border-radius: 6px;
            box-shadow: inset 7px 7px 14px black,
                        inset -7px -7px 14px #5a5a5a;">
                <label for="temp">Main Coal (TPH)</label>
                <div *ngIf="Realtimedata.length !=0 ">
                  <label class="per" *ngIf="vval.main_coal_tph < 0 ">0.00</label>
                  <label class="per" *ngIf="vval.main_coal_tph >=  0 ">{{vval.main_coal_tph}}</label>
                </div>
                <div *ngIf="Realtimedata.length ==0 || null "><label class="per">No data</label></div>
              </div>
            </div> -->
      </div>
    </div>
    <div class="red1">
      <div class="row" style="padding-left: 1%; padding-right: 1%">
        <div class="col-md-12">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding: 1%;
            "
          >
            <p class="mainGridtitle1">Forecasting Values</p>
            <span style="color: #fff">
              <tr *ngFor="let vval of ForecastKilndata">
                <!-- <td>{{vval.obs_time | date:'dd/MM/yyyy, HH:mm:ss'}}                 
                          </td> -->
                <td>Time -&nbsp;{{ vval.obs_time }}</td>
              </tr>
            </span>
          </div>
          <!-- <hr> -->

          <div class="row" style="padding: 1%">
            <div class="col-md-6" >
              <div
                class="red"
                style="
                  border-radius: 6px;
                  box-shadow: inset 7px 7px 14px black,
                    inset -7px -7px 14px #5a5a5a;
                "
              >
                <label for="temp">Free Lime (%)</label>
                <span  *ngIf="ForecastKilndata.length != 0">
                <div *ngFor="let vval of ForecastKilndata">
                  <label class="per" *ngIf="vval.free_lime < 0">0.00</label>
                  <label class="per" *ngIf="vval.free_lime >= 0">
                    {{ vval.free_lime }}
                  </label>
                </div>
                <span
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
                (click)="openDialogFreelimekiln()"
              >
                <img
                  src="../../../../assets/icons/charticon.png"
                  style="width: 15px; height: 15px; margin-top: 4px"
                />
                <p
                  style="
                    margin-bottom: 0px;
                    margin-left: 5px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                >
                  View Chart
                </p>
              </span>
              </span>
                <div *ngIf="ForecastKilndata.length == 0 || null">
                  <label class="per">No data</label>
                </div>
              
              </div>
            </div>
            <div class="col-md-6">

              <div
                class="red"
                style="
                  border-radius: 6px;
                  box-shadow: inset 7px 7px 14px black,
                    inset -7px -7px 14px #5a5a5a;
                "
              >
                <label for="temp">Burning Zone Temp (°C)</label>
                <span *ngIf="ForecastKilndata.length != 0">
                <div   *ngFor="let vval of ForecastKilndata">
                  <label class="per" *ngIf="vval.burning_zone_temp < 0"
                    >0.00</label
                  >
                  <label class="per" *ngIf="vval.burning_zone_temp >= 0">
                    {{ vval.burning_zone_temp }}
                  </label>
                </div>
                <span
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
                (click)="openDialogBurning()"
              >
                <img
                  src="../../../../assets/icons/charticon.png"
                  style="width: 15px; height: 15px; margin-top: 4px"
                />
                <p
                  style="
                    margin-bottom: 0px;
                    margin-left: 5px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                >
                  View Chart
                </p>
              </span>
              </span>
                <div *ngIf="ForecastKilndata.length == 0 || null">
                  <label class="per">No data</label>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-4">
                  <div class="red" style="border-radius: 6px;
                box-shadow: inset 7px 7px 14px black,
                            inset -7px -7px 14px #5a5a5a;">
                    <label for="temp">Kiln Feed (TPH)</label>
                    <div *ngIf="Realtimedata.length !=0 ">
                      <label class="per" *ngIf="vval.kiln_feed < 0 ">0.00</label>
                      <label class="per" *ngIf="vval.kiln_feed >=  0 ">{{vval.kiln_feed}}</label>
                    </div>
                    <div *ngIf="Realtimedata.length ==0 || null "><label class="per">No data</label></div>
                  </div>
                </div> -->
          </div>
          <div class="row" style="padding: 1%">
            <div class="col-md-6" >
              <div
                class="red"
                style="
                  border-radius: 6px;
                  box-shadow: inset 7px 7px 14px black,
                    inset -7px -7px 14px #5a5a5a;
                "
              >
                <label for="temp"
                  >Kiln Inlet O2 (%)
                  <!-- (M<sup>3</sup>/Hr) -->
                </label>
                <span *ngIf="ForecastKilndata.length != 0">
                <div  *ngFor="let vval of ForecastKilndata">
                  <label class="per" *ngIf="vval.kiln_inlet_o2 < 0">0.00</label>
                  <label class="per" *ngIf="vval.kiln_inlet_o2 >= 0">
                    {{ vval.kiln_inlet_o2 }}
                  </label>
                </div>
                <span
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
                (click)="openDialogkilninleto2()"
              >
                <img
                  src="../../../../assets/icons/charticon.png"
                  style="width: 15px; height: 15px; margin-top: 4px"
                />
                <p
                  style="
                    margin-bottom: 0px;
                    margin-left: 5px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                >
                  View Chart
                </p>
              </span></span>
                <div *ngIf="ForecastKilndata.length == 0 || null">
                  <label class="per">No data</label>
                </div>
              
              </div>
            </div>

            <div class="col-md-6" >
              <div
                class="red"
                style="
                  border-radius: 6px;
                  box-shadow: inset 7px 7px 14px black,
                    inset -7px -7px 14px #5a5a5a;
                "
              >
                <label for="temp">Kiln Inlet CO (%)</label>
                <span *ngIf="ForecastKilndata.length != 0" >
                <div *ngFor="let vval of ForecastKilndata">
                  <label class="per" *ngIf="vval.kiln_inlet_co < 0">0.00</label>
                  <label class="per" *ngIf="vval.kiln_inlet_co >= 0">
                    {{ vval.kiln_inlet_co }}
                  </label>
                </div>
                <span
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
                (click)="openDialogkilninletco()"
              >
                <img
                  src="../../../../assets/icons/charticon.png"
                  style="width: 15px; height: 15px; margin-top: 4px"
                />
                <p
                  style="
                    margin-bottom: 0px;
                    margin-left: 5px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                >
                  View Chart
                </p>
              </span>
            </span>
                <div *ngIf="ForecastKilndata.length == 0 || null">
                  <label class="per">No data</label>
                </div>
              
              </div>
            </div>
            <!-- <div class="col-md-4">
                  <div class="red" style="border-radius: 6px;
                box-shadow: inset 7px 7px 14px black,
                            inset -7px -7px 14px #5a5a5a;">
                    <label for="temp">Main Coal (TPH)</label>
                    <div *ngIf="Realtimedata.length !=0 ">
                      <label class="per" *ngIf="vval.main_coal_tph < 0 ">0.00</label>
                      <label class="per" *ngIf="vval.main_coal_tph >=  0 ">{{vval.main_coal_tph}}</label>
                    </div>
                    <div *ngIf="Realtimedata.length ==0 || null "><label class="per">No data</label></div>
                  </div>
                </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 1%;
        margin-top: 1%;
      "
    >
      <div>
        <span
          ><button mat-raised-button color="primary" (click)="onPrevClick()">
            Previous
          </button></span
        >
        <!-- <span *ngIf="this.selectedDatenext=='1660847400'"><button mat-raised-button disabled style="border: 1px solid #999999;
              background-color: #cccccc;
              color: #666666;">
                Previous</button></span> -->
      </div>
      <button mat-raised-button color="primary" (click)="onNextclick()">
        Next
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" style="height: 75vh; display: grid; width: 100%">
    <div style="margin: auto">
      <img
        src="../../../../assets/icons/Spinner.gif"
        style="width: 80px"
      />
      <p style="text-align: center;color: #fff;">Loading...</p>
    </div>
  </div>
</section>
